import React from "react";
import { Modal, Row } from "react-bootstrap";
import { EMPTY_STRING } from "../../../constants";
import ModalActionButtons from "./ModalActionButtons"; // adjust path

const CustomBodyModal = (props) => {
  const {
    children,
    size = "lg",
    show = false,
    animation = true,
    onHide = () => {},
    title = EMPTY_STRING,
    className = EMPTY_STRING,
    dialogClassName = EMPTY_STRING,
    backdropClassName = EMPTY_STRING,

    // Header
    closeButton = true,

    // Action buttons (opt-in, so existing usages are unaffected)
    showActionButtons = false,
    onSubmit,
    onCancel, // falls back to onHide
    isLoading = false,
    cancelButtonLabel,
    submitButtonLabel,
    actionButtonsClassName = "mt-4 p-0",
  } = props;

  const handleFormSubmit = (e) => {
    e.preventDefault();
    // portals bubble React events, so don't let a parent form receive this submit
    e.stopPropagation();
    onSubmit?.(e);
  };

  return (
    <Modal
      centered
      size={size}
      show={show}
      onHide={onHide}
      backdrop="static"
      animation={animation}
      dialogClassName={dialogClassName}
      backdropClassName={backdropClassName}
      className={`add-inventory-modal ${className}`}
    >
      <Modal.Header
        closeButton={closeButton}
        className="add-inventory-modal-header"
      >
        <Modal.Title>
          <span className="add-inventory-modal-header-name">{title}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {showActionButtons ? (
          <form onSubmit={handleFormSubmit}>
            {children}
            <Row className="m-0 p-0">
              <ModalActionButtons
                className={actionButtonsClassName}
                handleCloseModal={onCancel || onHide}
                isLoading={isLoading}
                cancelButtonLabel={cancelButtonLabel}
                submitButtonLabel={submitButtonLabel}
              />
            </Row>
          </form>
        ) : (
          children
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CustomBodyModal;
